import { Button, Drawer, Flex, Stack, Title, em } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useContext } from "react";
import { AbstractDrawerProps } from "../../@types";
import CartDrawerStateContext from "../../context/CartDrawerStateContext";
import useCart, { CartItemType } from "../../hooks/useCart";
import { RoutePaths } from "../../router";
import { enhanceCurrency } from "../../utils/formatter";
import CartNavbarDrawerItem from "./CartNavbarDrawerItem";

export default function CartNavbarDrawer({
  ...props
}: Partial<AbstractDrawerProps<{}>>) {
  const { isOpen, setOpen } = useContext(CartDrawerStateContext);
  const isTabletSize = useMediaQuery(`(min-width: ${em(720)})`, true, {
    getInitialValueInEffect: false,
  });
  const handleOnClose = () => {
    setOpen && setOpen(false);
  };
  const [cart, setCart] = useCart();

  const handleOnChangeQuantity = (item: CartItemType, quantity: number) => {
    let cartMap = new Map(cart);
    const identifier = item.id + item.typeId;
    let cartItem = cart.get(identifier);

    if (!cartItem) {
      throw new Error(`Unable to find cart item with key ${identifier}`);
    }

    cartItem.quantity = quantity;
    cartMap.set(identifier, cartItem);

    setCart(cartMap);
  };

  const handleRemove = (item: CartItemType) => {
    const identifier = item.id + item.typeId;
    setCart((cart) => {
      cart.delete(identifier);
      return new Map(cart);
    });
  };

  const handleCheckout = () => {
    handleOnClose();
  };

  const calculateTotal = () => {
    return Array.from(cart.values()).reduce((previousValue, currentItem) => {
      let value = previousValue;
      value +=
        currentItem.discountPrice === undefined ||
        currentItem.discountPrice === null
          ? Number(currentItem.actualPrice || 0) * currentItem.quantity
          : Number(currentItem.discountPrice || 0) * currentItem.quantity;
      return value;
    }, 0);
  };

  return (
    <Drawer
      {...props}
      size={isTabletSize ? "45%" : "85%"}
      opened={(isOpen && isOpen) || false}
      onClose={handleOnClose}
      position="right"
      className="relative"
      title={
        <Title component={"a"} order={2}>
          Giỏ hàng hiện tại
        </Title>
      }
    >
      <Flex
        direction={"column"}
        gap={4}
        className="max-h-[calc(100%-64px)] overflow-y-auto"
      >
        {cart !== undefined &&
          Array.from(cart.values()).map((item) => {
            return (
              <CartNavbarDrawerItem
                id={item.id}
                typeId={item.typeId}
                typeName={item.typeName}
                typeValue={item.typeValue}
                quantity={item.quantity}
                key={`${item.id}${item.typeId}`}
                onChangeQuantity={(quantity) =>
                  handleOnChangeQuantity(item, quantity)
                }
                onRemove={() => handleRemove(item)}
                // onPriceUpdate={(price) => handlePriceChange(item, price)}
              />
            );
          })}
      </Flex>
      {cart.size === 0 && (
        <div className="text-neutral-400 font-medium">
          Hiện tại không có sản phẩm nào
        </div>
      )}
      {cart && cart.size > 0 && (
        <Stack className="sticky bottom-0 px-4 py-2 border-t z-40 bg-neutral-50/30 backdrop-blur-md -mx-4 rounded-b-md">
          <Flex direction={"row"} justify={"end"} gap={12} align={`center`}>
            <span className="text-sm">Thành tiền: </span>
            <span className="font-bold text-xl text-primary">
              {enhanceCurrency(calculateTotal())} đ
            </span>
          </Flex>

          <Button
            size="md"
            radius={"sm"}
            component={"a"}
            hiddenFrom="md"
            href={RoutePaths.Checkout}
            onClick={handleCheckout}
          >
            Đi đến thanh toán
          </Button>

          <Button
            size="sm"
            radius={"sm"}
            component={"a"}
            visibleFrom="md"
            href={RoutePaths.Checkout}
            onClick={handleCheckout}
          >
            Đi đến thanh toán
          </Button>
        </Stack>
      )}
    </Drawer>
  );
}
